import {Component, OnInit, Injector, ElementRef, ViewChild, AfterViewInit, ViewEncapsulation} from '@angular/core';
import {MobileLandingPageComponent} from '../mobile-landing-page/mobile-landing-page.component';
import {ChartLayoutModeService} from '../../services/chartLayoutMode/chartLayoutMode.service';

import * as $ from "jquery";
import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js";
import {DataService} from '../../services/data/data.service';
import {ShowOpenLiveAccountMobileModal} from '../modals/mobile-open-live-account/mobile-open-live-account.component';
import {chartLinesService} from '../../services/chartLinesService';

@Component({
    selector: 'app-mobile-quickbar',
    template: require('./mobile-quickbar.component.html'),
    encapsulation: ViewEncapsulation.None,
    styles: [require('./mobile-quickbar.component.scss')]
})
export class MobileQuickbarComponent extends MobileLandingPageComponent implements OnInit, AfterViewInit {

    @ViewChild('tileRow') tileRow!: ElementRef;

    constructor(injector: Injector, activeLayoutTypeService: ChartLayoutModeService, public dataService: DataService,  public tradeLinesVisibilityService:chartLinesService) {
        super(injector, activeLayoutTypeService, dataService, tradeLinesVisibilityService);
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.initScroll();
    }

    public get debugVisibility() {
        return this.workspace.debugVisibility
    }

    openLiveAccountModal() {
        if(!this.workspaceService.data.LoginModalCreated) {
            ShowOpenLiveAccountMobileModal(this.modalService).modeOpen = true;
        }
    }

    withdrawalLiveAccountModal() {
        if(!this.workspaceService.data.LoginModalCreated) {
            ShowOpenLiveAccountMobileModal(this.modalService).modeOpen = false;
        }
    }

    public initScroll() {
        console.log("init scroll");
        $(this.tileRow.nativeElement).mCustomScrollbar({
            axis: "x",
            autoHideScrollbar: true,
            advanced: {
                autoExpandHorizontalScroll: true, //optional (remove or set to false for non-dynamic/static elements)
                updateOnContentResize: true
            },
            scrollButtons: {enable: false},
            contentTouchScroll: true,
            documentTouchScroll: true,
        });
    }
}
